/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Redshift snapshot properties for native AWS Backup snapshots.
*/
export class RedshiftSnapshotProperties {
  /**
  * AWS Backup recovery point ARN.
  */
  'recoveryPointArn'?: string;
  /**
  * AWS Backup vault name where the backup is stored.
  */
  'backupVaultName'?: string;
  /**
  * AWS region where the backup is stored.
  */
  'region'?: string;
  /**
  * AWS account ID where the backup is stored.
  */
  'sourceAccountId'?: string;
  /**
  * Redshift cluster identifier.
  */
  'clusterIdentifier'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "recoveryPointArn",
      "baseName": "recoveryPointArn",
      "type": "string",
      "format": ""
    },
    {
      "name": "backupVaultName",
      "baseName": "backupVaultName",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "sourceAccountId",
      "baseName": "sourceAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "clusterIdentifier",
      "baseName": "clusterIdentifier",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RedshiftSnapshotProperties.attributeTypeMap;
  }

  public constructor() {
  }
}

